import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-group-bookings',
  templateUrl: './group-bookings.component.html',
  styleUrls: ['./group-bookings.component.css']
})
export class GroupBookingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
